import { cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";


export type BadgeProps = React.ComponentProps<"span"> & {
    intent: "primary" | "info" | "warning" | "error" | "success" | "default";
    text: string | number;
}

const Badge = (props: BadgeProps) => {
    const {className, ...rest} = props; 
    const badgeClass = () => {

        const defaultClass = `inline-flex justify-center items-center gap-2 
        text-xs capitalize px-2 py-0.5 rounded-lg`

        const config = {
            variants: {
                intent: {
                    primary: "bg-primary-50 text-primary",

                    info: "bg-blue-100 text-blue-600",

                    warning: "bg-yellow-100 text-yellow-600",

                    error: "bg-red-100 text-red-600",

                    success: "bg-green-100 text-green-600",

                    default: "bg-zinc-100 text-zinc-600",
                }
            }
        }

        return cva(defaultClass, config)({
            intent: props.intent
        })
    };

    return (
        <span 
            className={twMerge(badgeClass(), props.className)}
            {...rest}
        >
            <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
            <span>{props.text}</span>
        </span>
    );
}

export default Badge
